import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { GoToTop } from './../../Commons/GoToTop'
import { useAuth } from '../../Providers/AuthProvider'


const Base = (props) => {
    const navigate = useNavigate()
    const { logout } = useAuth()

    const [theme,setTheme] = useState(0)
    

    const ChangeTheme = async () => {
        try {
            if (document.body.classList.contains("DarkTheme")) {
                document.body.classList.remove("DarkTheme")
                setTheme(0)
            } else {
                document.body.classList.add("DarkTheme")
                setTheme(1)
            }
        } catch (error) {
            
        }
    }

    const Logout = async () => {
        try {
            await logout()
            navigate("/login")
        } catch (error) {
            navigate("/login")
        }
    }

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            <header className='Header container'>
                <button type='button' className='Header__Buttons Btn__Adsl--RedOutline' onClick={ChangeTheme}>
                    {theme === 1 ? (
                        <i className="bi bi-sun"></i>
                    ) : (
                        <i className="bi bi-moon"></i>
                    )}
                </button>

                <button type='button' className='Header__Buttons Btn__Adsl--RedOutline' onClick={Logout}>
                    <i className="bi bi-box-arrow-right"></i>
                </button>
            </header>

            <main className="container Dashboard Container-FullHeight">
                {props?.urlToGo && (
                    props.urlToGo !== '' && (
                        <div className="ReturnButton">
                            <button className='ReturnButton__Button' onClick={() => navigate(props.urlToGo)}>
                                <i className="bi bi-arrow-90deg-left fs-5"></i>
                            </button>
                        </div>
                    )
                )}

                <div className="row mt-3">
                    {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL" alt="Logo" /> */}
                    <img src="/img/page/spins-five.png" className="LogoADSL" alt="Logo" />

                    <div className="mt-5">
                        {props.children}
                    </div>
                </div>
            </main>

            <GoToTop />

            <footer className='container'>
                <p className='text-center FooterCredits'>Hecho con ♥ por Interaktia | 2026</p>
            </footer>
        </>
    )
}

export { Base };